<template>
  <div id="client-shipping-address-info-form">
    <v-layout justify-center>
      <v-flex
        xs12
        sm10
        md8
        lg6
      >
        <v-card ref="form">
          <v-card-text>
            <v-text-field
              @change="checkIfIsFilled()"
              ref="name"
              v-model="name"
              :rules="[() => !!name || 'Campo obrigatório']"
              :error-messages="errorMessages"
              label="Nome completo"
              placeholder="Vishnu Bhagavan"
              required
            ></v-text-field>
            <v-text-field
              @change="checkIfIsFilled()"
              ref="address"
              :rules="[
              () => !!address || 'Campo obrigatório',
              () => !!address && address.length >= 10 || 'Endereço deve conter no mínimo 10 caracteres',
              addressCheck,
              () => (!address || !!address && !!address.match(/\d/)) || 'Informe o número do local de entrega!'
            ]"
              v-model="address"
              label="Logradouro e número"
              placeholder="Vaikuntha Dhama, 108"
              required
            ></v-text-field>
            <v-text-field
              @change="checkIfIsFilled()"
              ref="city"
              :rules="[() => !!city || 'Campo obrigatório', addressCheck]"
              v-model="city"
              label="Cidade"
              placeholder="Dhruva Loka"
              required
            ></v-text-field>
            <v-text-field
              @change="checkIfIsFilled()"
              ref="state"
              v-model="state"
              :rules="[() => !!state || 'Campo obrigatório']"
              label="Estado/Província/Região"
              required
              placeholder="HK"
            ></v-text-field>
            <v-text-field
              @change="checkIfIsFilled()"
              ref="email"
              :rules="[() => !!email || 'Campo obrigatório']"
              v-model="email"
              label="Email"
              required
              placeholder="insira_seu@email.com"
            ></v-text-field>
            <v-text-field
              ref="zip"
              :rules="[() => !!zip || 'Campo obrigatório']"
              v-model="zip"
              label="Cep / Código Postal"
              required
              placeholder="88549-020"
              @change="getValue()"
            ></v-text-field>
            <v-progress-linear
              indeterminate
              color="teal"
              v-show="showFareValueProgress"
            ></v-progress-linear>
            <v-text-field
              ref="fareValueRef"
              v-model="fareValueToDisplay"
              label="Valor do frete"
              disabled
            >
            </v-text-field>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <!-- <v-btn>Cancelar</v-btn> -->
            <v-spacer></v-spacer>
            <v-slide-x-reverse-transition>
              <v-tooltip
                v-if="formHasErrors"
                left
              >
                <v-btn
                  slot="activator"
                  icon
                  class="my-0"
                  @click="resetForm"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
                <span>Atualizar</span>
              </v-tooltip>
            </v-slide-x-reverse-transition>
            <!-- <v-btn
              color="primary"
              @click="submit"
            >Próximo</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  name: "client-information-form",
  props: ["baseUrl", "debugging"],
  mounted() {
    if (this.debugging) {
      this.address = "rua frans 31"
      this.city = "Florianópolis"
      this.name = "adriel"
      this.state = "Santa Catarina"
      this.zip = "88010030"
      this.email = "ad@w.com"
       this.$emit("clientInfoFilled", {
          name: this.name,
          address: this.address,
          city: this.city,
          state: this.state,
          zip: this.zip,
          email: this.email
        })
    }
  },
  data() {
    return {
      showFareValueProgress: false,
      fareValueToDisplay: null,
      fareValueRaw: null,
      errorMessages: "",
      name: null,
      address: null,
      city: null,
      state: null,
      zip: null,
      email: null,
      formHasErrors: false
    }
  },
  computed: {
    form() {
      return {
        name: this.name,
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip
      }
    }
  },

  watch: {
    name() {
      this.errorMessages = ""
    }
  },

  methods: {
    checkIfIsFilled() {
      if (
        this.name &&
        this.name.length > 5 &&
        (this.address &&
        this.address.length > 8 &&
        this.address.match(/\d/)) &&
        this.city &&
        this.city.length > 4 &&
        this.state &&
        this.state.length >= 2 &&
        this.zip &&
        this.zip.length > 7 &&
        this.email &&
        this.email.length > 4 &&
        this.email.indexOf("@") > -1
      ) {
        this.$emit("clientInfoFilled", {
          name: this.name,
          address: this.address,
          city: this.city,
          state: this.state,
          zip: this.zip,
          email: this.email
        })
        return
      } else if (!this.address || (this.address && !this.address.match(/\d/))) {
        this.$emit(
          "userFeedBackInfo", 1
        )
        return
      }
      
      this.$emit("clientInfoFilled", "not-filled")
    },
    getValue() {
      if (this.zip && this.zip.length > 7) {
        this.fareValueToDisplay = "Consultando valor, aguarde!"
        this.zip = this.zip.replace("-", "")
        let url = new URL(this.baseUrl + "/fare-value")
        url.searchParams.append("zipCode", this.zip)
        url.searchParams.append("product", this.zip)
        fetch(url, { method: "GET" })
          .then(response => response.json())
          .then(result => {
            const fairValue = result.fairValue[0]
            if (!fairValue.Erro) {
              this.fareValueToDisplay = `R$ ${fairValue.Valor}`
              this.fareValueRaw = Number.parseFloat(
                fairValue.Valor.replace(",", ".")
              ).toFixed(2) // fairValue.Valor
            } else {
              this.$emit(
                "userFeedBackInfo",
                "Não foi possível encontrar o valor do frete. Será cobrado 30 reais como valor default. " +
                  result.Erro
              )
              this.fareValueRaw = 30
              this.fareValueToDisplay = "R$ 30"
            }
          })
      } else {
        this.fareValueToDisplay =
          "Para consultar valor de frete insira o cep completo"
        this.$emit(
          "userFeedBackInfo",
          "Para consultar valor de frete insira o cep completo"
        )
      }
    },
    addressCheck() {
      this.errorMessages = this.address && !this.name ? "Campo obrigatório" : ""

      return true
    },
    resetForm() {
      this.errorMessages = []
      this.formHasErrors = false

      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset()
      })
    },
    submit() {
      this.formHasErrors = false

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true

        this.$refs[f].validate(true)
      })
    }
  }
}
</script>

<style>
input[disabled="disabled"],
.v-label.v-label--active.v-label--is-disabled.theme--light {
  color: black !important;
  font-size: 20px;
}
</style>